import React from 'react'
import { CreateIBProfileInstrument } from 'api/Trading-Accounts/Types/CreateIBProfileInstrument'
import { InstrumentDto } from 'api/Trading-Accounts/Types/InstrumentDto'

import { AddIntroducingBrokerInstrumentForm } from './IntroducingBrokerProfileInstrumentsAddInstrumentForm'

interface Props {
  allInstruments: InstrumentDto[]
  ibProfileInstruments: InstrumentDto[]

  onSubmit(values: CreateIBProfileInstrument): Promise<void>
}

export const IntroducingBrokerProfileInstrumentsAddInstrumentPage: React.FC<Props> = ({
  allInstruments,
  ibProfileInstruments,
  onSubmit,
}) => {
  return (
    <AddIntroducingBrokerInstrumentForm
      instruments={filterExistingRecords(allInstruments, ibProfileInstruments)}
      onSubmit={onSubmit}
    />
  )
}

const filterExistingRecords = (
  allInstruments: InstrumentDto[],
  ibProfileInstruments: InstrumentDto[]
) => {
  const allInstrumentsMap = ibProfileInstruments.reduce(
    (previousValue: { [instrumentId: string]: InstrumentDto }, currentValue: InstrumentDto) => {
      return {
        ...previousValue,
        [currentValue.id]: currentValue,
      }
    },
    {}
  )

  return allInstruments.filter((x) => !allInstrumentsMap[x.id])
}
